import { AppConfig } from '../../../../app/config/app-config';

export const FEATURE_KEY = 'claim-cme-ce';

export enum AssignmentStatusTypes {
    INIT,
    SUCCESS,
    FAILURE,
}

export enum AssignmentStatusMessageTypes {
    ERROR,
    WARNING,
}

export class AssignmentStatus {
    message: string;
    type: AssignmentStatusMessageTypes;
}

const getAssignmentStatusCodeError = (status: any): AssignmentStatus => {
    const AssignmentStatusCodeErrorMap = new Map([
        ['-100', { message: 'Contact the Site Administrator.', type: AssignmentStatusMessageTypes.WARNING }],
        [
            '-101',
            {
                message: `<a href="${AppConfig.settings.capContactUrl}" target="_blank">Contact the CAP</a>`,
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        ['-102', { message: 'Please allow one or two business days.', type: AssignmentStatusMessageTypes.WARNING }],
        [
            '-103',
            {
                message: 'This Kit # is associated with another user ID. Enter a different Kit #.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        ['-104', { message: 'Contact the CAP.', type: AssignmentStatusMessageTypes.WARNING }],
        [
            '-105',
            {
                message: 'You have entered an invalid Kit # / CAP # combination. Re-enter Kit # and CAP #.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        [
            '-107',
            {
                message: 'This Survey does not allow continuing education credits.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        ['-110', { message: 'This kit was faxed after due date.', type: AssignmentStatusMessageTypes.WARNING }],
        [
            '-111',
            { message: 'You already have another kit for this survey.', type: AssignmentStatusMessageTypes.WARNING },
        ],
        [
            '-200',
            {
                message: 'This Kit # is associated with another user ID. Enter a different Kit #.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        [
            '-201',
            {
                message: 'You have already claimed credit using a different kit number.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        ['-202', { message: 'No Learning Activity found', type: AssignmentStatusMessageTypes.WARNING }],
        ['-203', { message: 'No Learning Activity found.', type: AssignmentStatusMessageTypes.WARNING }],
        ['-204', { message: 'No activity code found', type: AssignmentStatusMessageTypes.WARNING }],
        [
            '-205',
            {
                message: 'Multiple activity codes have been found for this kit number.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        ['-206', { message: 'You have already claimed this kit.', type: AssignmentStatusMessageTypes.WARNING }],
        [
            '-207',
            {
                message: 'This Kit # is associated with another user ID. Enter a different Kit #.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        [
            '-208',
            {
                message: 'You have already claimed credit using a different kit number.',
                type: AssignmentStatusMessageTypes.WARNING,
            },
        ],
        [
            '-299',
            {
                message: 'An error occured when transmitting your completion to the Education site for credit, please contact us with the following.',
                type: AssignmentStatusMessageTypes.ERROR,
            },
        ],
    ]);

    const DEFAULT_STATUS: AssignmentStatus = {
        message: `We are sorry, an unexpected error occurred while processing your request. <a href="${AppConfig.settings.capContactUrl}" target="_blank">Contact the CAP</a>.`,
        type: AssignmentStatusMessageTypes.ERROR,
    };

    const error = AssignmentStatusCodeErrorMap.get(status);

    if (!error) {
        return DEFAULT_STATUS;
    }

    return error;
};

export { getAssignmentStatusCodeError };
